// 内核判断
const deviceCore = {
  _ua: navigator.userAgent.toLowerCase(),
  // 获取浏览器版本
  _getVersion: (nece) => {
    let arr = nece.split(".");
    return parseFloat(`${arr[0]}.${arr[1]}`);
  },
  // 设备检测
  _detect: (kernel) => {
    let reg = new RegExp(kernel, "img");
    return reg.test(deviceCore._ua);
  },
};
export const device = {
  isIOS: () => {
    return deviceCore._detect("iPhone|iPad|iPod|iOS|mac os");
  },
  isAndroid: () => {
    return deviceCore._detect("Android");
  },
  isUCBrowser: () => {
    return deviceCore._detect("UCBrowser");
  },
  isQQBrowser: () => {
    return deviceCore._detect("QQBrowser");
  },
  isWeixin: () => {
    return deviceCore._detect("MicroMessenger");
  },
  isPC: () => {
    return !deviceCore._detect(
      "phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone"
    );
  },
  qqBrowserVersion: () => {
    return device.isQQBrowser()
      ? deviceCore._getVersion(deviceCore._ua.split("mqqbrowser/")[1])
      : 0;
  },
  ucBrowserVersion: () => {
    return device.isUCBrowser()
      ? deviceCore._getVersion(deviceCore._ua.split("ucbrowser/")[1])
      : 0;
  },
  iOSVersion: () => {
    return device.isIOS()
      ? parseInt(deviceCore._ua.match(/\s*os\s*\d+/gi)[0].split(" ")[2], 10)
      : 0;
  },
  isGomeCard: () => {
    return deviceCore._detect("gomecard");
  },
};

/**
 * @description: 获取某个时间格式的时间戳
 * @param {String} dateString "2019-03-15 18:19:07"
 * @return:
 */
export const dateToTimestamp = (dateString) => {
  var timestamp = Date.parse(new Date(dateString.replace(/\-/g, "/")));
  timestamp = timestamp / 1000;
  return timestamp;
};

/**
 * [日期格式化]
 * @param {any}    date   日期
 * @param {string} format 日期格式
 * for example:
 *  format = 'yyyyMMddhhmmss'           -> '20180619135353'
 *  format = 'yyyy-MM-dd hh:mm:ss'      -> '2018-06-19 13:53:53'
 *  format = 'yyyy年MM月dd日hh时mm分ss秒' -> '2018年06月19日13时53分53秒'
 */
export const dateFormat = (date, format = "yyyyMMddhhmmss") => {
  if (!date) {
    date = new Date();
  }
  if (typeof date === "string" && /^\d+$/.test(date)) {
    date = new Date(+date);
  }
  if (typeof date === "number") {
    date = new Date(date);
  }
  if (typeof date !== "number" && !(date instanceof Date)) {
    date = date.replace(/年|月/g, "-").replace(/日/g, "");
    date = new Date(date);
  }

  const o = {
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      String(date.getFullYear()).substr(4 - RegExp.$1.length)
    );
  }
  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : `00${o[k]}`.substr(String(o[k]).length)
      );
    }
  });
  return format;
};

/** 手机号输入时空格处理 3+4+4 */
export const formatPhoneNo = (e, value) => {
  var phoneNum = value.trim();
  // 如果是删除按键，则什么都不做
  if (e.keyCode === 8) {
    return phoneNum;
  }
  var len = phoneNum.length;
  if (len === 3 || len === 8) {
    phoneNum += " ";
  }
  return phoneNum;
};

/*
 * 校验手机号
 */
export const checkPhone = (tel, callback) => {
  let boolStr;
  const reg = /^1[3456789]\d{9}$/g;
  boolStr = reg.test(tel);
  callback ? callback(boolStr) : "";
  return boolStr;
};

/** 校验姓名 */
export const checkName = (name, callback) => {
  let boolStr;
  const reg =
    /(^[\u4e00-\u9fa5]+[\u4e00-\u9fa5·•]+[\u4e00-\u9fa5]+$)|(^[\u4e00-\u9fa5]+$)/;
  boolStr = reg.test(name);
  callback ? callback(boolStr) : "";
  return boolStr;
};

/** 校验银行卡号 */
export const checkBankCard = (cardNo, callback) => {
  let boolStr;
  const reg = /^[0-9]*$/;
  boolStr = reg.test(cardNo) || cardNo.length > 19;
  callback ? callback(boolStr) : "";
  return boolStr;
};

/** 校验身份证号 */
export const checkIDCard = (val, callback) => {
  if (checkCode(val)) {
    var date = val.substring(6, 14);
    if (checkDate(date)) {
      if (checkProv(val.substring(0, 2))) {
        return true;
      }
    }
  }
  return false;
};
var checkCode = function (val) {
  var p =
    /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  var parity = [1, 0, "X", 9, 8, 7, 6, 5, 4, 3, 2];
  var code = val.substring(17);
  if (p.test(val)) {
    var sum = 0;
    for (var i = 0; i < 17; i++) {
      sum += val[i] * factor[i];
    }
    if (parity[sum % 11] === code.toUpperCase()) {
      return true;
    }
  }
  return false;
};

var checkDate = function (val) {
  var pattern =
    /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/;
  if (pattern.test(val)) {
    var year = val.substring(0, 4);
    var month = val.substring(4, 6);
    var date = val.substring(6, 8);
    var date2 = new Date(year + "-" + month + "-" + date);
    if (date2 && date2.getMonth() === parseInt(month) - 1) {
      return true;
    }
  }
  return false;
};

var checkProv = function (val) {
  var pattern = /^[1-9][0-9]/;
  var provs = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江 ",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北 ",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏 ",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
  };
  if (pattern.test(val)) {
    if (provs[val]) {
      return true;
    }
  }
  return false;
};

/* 格式化输入的手机号 */
export function formatMobile(e, el, val) {
  let selStart = el.selectionStart;
  let mobileLen = val.length;
  let value = getValue(e, val, 11);
  let len = value.length;
  if (len > 3 && len < 8) {
    value = value.replace(/^(\d{3})/g, "$1 ");
  } else if (len >= 8) {
    value = value.replace(/^(\d{3})(\d{4})/g, "$1 $2 ");
  }
  el.value = value;
  if (selStart !== mobileLen) {
    if (selStart === 3) {
      selStart++;
    }
    el.selectionStart = el.selectionEnd = selStart;
  }
}

/* 格式化输入的银行卡号*/
export function formatCardNumber(e, el, val) {
  let selStart = el.selectionStart;
  let mobileLen = val.length;
  let value = getValue(e, val, 23);
  let len = value.length;
  if (len > 4 && len < 9) {
    value = value.replace(/^(\d{4})/g, "$1 ");
  }
  if (len >= 9 && len < 13) {
    value = value.replace(/^(\d{4})(\d{4})/g, "$1 $2 ");
  }
  if (len >= 13 && len < 17) {
    value = value.replace(/^(\d{4})(\d{4})(\d{4})/g, "$1 $2 $3 ");
  }
  if (len >= 17 && len < 20) {
    value = value.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})/g, "$1 $2 $3 $4 ");
  }
  el.value = value;
  if (selStart !== mobileLen) {
    el.selectionStart = el.selectionEnd = selStart;
  }
}
/* 获取输入框内容(手动输入/复制粘贴) */
export function getValue(e, val) {
  let value = "";
  if (e.type === "keyup") {
    value = val.replace(/\D/g, "");
  } else if (e.type === "paste") {
    if (window.clipboardData && window.clipboardData.getData) {
      value = window.clipboardData.getData("Text");
    } else {
      value = e.clipboardData.getData("Text");
    }
    // value = value.replace(/\D/g, "");
  }
  return value;
}

/**
 *  获取urlParams
 * @param   name  {[String]}  [Key]
 * @returns {value of null}
 */
export function getUrlParam(name, url) {
  if (typeof name !== "string") return false;
  if (!url) url = window.location.href;
  // 当遇到name[xx]时，对方括号做一下转义为 name\[xxx\]，因为下面还需要使用name做正则
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}
/**
 * 将url转为地址参数格式
 * @param {*} param
 * @param {*} key
 * @param {*} encode
 */
export function tranObjToParams(param, key, encode) {
  if (param == null) return "";
  var paramStr = "";
  var t = typeof param;
  if (t == "string" || t == "number" || t == "boolean") {
    paramStr +=
      "&" +
      key +
      "=" +
      (encode == null || encode ? encodeURIComponent(param) : param);
  } else {
    for (var i in param) {
      var k =
        key == null
          ? i
          : key + (param instanceof Array ? "[" + i + "]" : "." + i);
      paramStr += tranObjToParams(param[i], k, encode);
    }
  }
  return paramStr;
}
/**
 * [url 参数]
 */
export const urlQuery = {
  _url: window.location.href,
  _set(key, value, location) {
    if (location) {
      this._url = location;
    }

    let flag = false;
    let queryStr = this._url.split("?");

    if (queryStr[1]) {
      let list = queryStr[1].split("&");
      for (let i = 0; i < list.length; i++) {
        let queryList = list[i].split("=");
        if (queryList[0] === key) {
          flag = true;
          queryList[1] = value;
          list[i] = queryList.join("=");
          break;
        }
      }
      let query = list.join("&");
      if (!flag) {
        query += `&${key}=${value}`;
      }

      return queryStr[0] + "?" + query;
    } else {
      return (this._url += `?${key}=${value}`);
    }
  },

  _get(key, def) {
    let reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`);
    let r = window.location.search.substr(1).match(reg);

    if (r !== null) {
      return unescape(r[2]);
    }
    return def || null;
  },

  _getAll() {
    let queryStr = window.location.href.split("?");
    if (queryStr[1]) {
      let gets = queryStr[1].split("&");
      let get = [];
      for (i = 0; i < gets.length; i++) {
        let item = gets[i].split("=");
        let key = item[0];
        get[key] = item[1];
      }
    }
    return queryStr[1];
  },
};

/**
 * 删除对象中多个属性
 * @param {*} obj
 * @param {*} keys []
 */
export function delObjKeys(obj, keys) {
  keys.map(function (key) {
    delete obj[key];
  });
  return obj;
}

/* 判断字符串是否为空
 * @param {*} property
 */
export function isEmpty(property) {
  return (
    property === null || property === "" || typeof property === "undefined"
  );
}

/**
 * 姓名校验:中文加·
 * 手机号校验:1开头的11位数字
 * 身份证校验:19位数字后面加X
 * 银行卡校验:只能输入数字
 */
export const validate = {
  name: /[^\u4E00-\u9FA5|·]/g, // 非中文输入
  mobile: /^1\d{10}$/,
  idCard: /[\W]/, // 匹配特殊字符
  idCardReg: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
  bankCardNo: /\D/g, // 匹配非数字
};

export const baseURL = `${window.location.origin + window.location.pathname}`;

/**
 * 向下取整百
 * @param {String, Number} num
 */
export function ceilNum(num) {
  return num && Math.floor(num / 100) * 100;
}

/**
 * 切割跳转地址
 * @param {String} url
 */
export function sliceUrl(url) {
  /^http.*#(.*)/.test(url);
  const matched = RegExp.$1.split("?");
  const path = matched[0];
  let query = {};
  if (matched[1]) {
    let list = matched[1].split("&");
    list.forEach((item) => {
      const itm = item.split("=");
      query[itm[0]] = itm[1];
    });
  }
  return {
    path,
    query,
  };
}
/**
 * 手机号脱敏
 * @param {String} tel
 */
export function formatTel(tel) {
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  return tel.replace(reg, "$1****$2");
}
/**
 * 姓名脱敏
 * @param {String} userNameChar
 */
export function formatName(userNameChar) {
  if (userNameChar.length == 2) {
    userNameChar = userNameChar.substring(0, 1) + "*"; //截取name 字符串截取第一个字符，
  } else if (userNameChar.length == 3) {
    userNameChar =
      userNameChar.substring(0, 1) + "*" + userNameChar.substring(2, 3); //截取第一个和第三个字符
  } else if (userNameChar.length > 3) {
    userNameChar =
      userNameChar.substring(0, 1) +
      "*" +
      "*" +
      userNameChar.substring(userNameChar.length - 1, userNameChar.length); //截取第一个和大于第4个字符
  }
  return userNameChar;
}
/**
 * 身份证脱敏
 * @param {String} idNo
 */
export function formatIDcard(idNo) {
  return idNo.replace(/^(\d{4})\d+([\dXx]{4})$/, "$1********$2");
}
/**
 * 银行卡号脱敏
 * @param {String} card
 */
export function formatBankCard(card) {
  return card.replace(/^(\d{4})\d+(\d{4})$/, "$1********$2");
}

/**
 * 节流函数
 * @param
 */
export function throttleFn(handle, wait) {
  if (typeof handle !== "function") throw new Error("must be function");
  if (typeof wait === "undefined") wait = 400;
  let pre = 0;
  let timer = null;
  return function proxy(...args) {
    let now = new Date();
    let self = this;
    let interval = wait - (now - pre);
    if (interval <= 0) {
      clearTimeout(timer);
      timer = null;
      handle.call(self, ...args);
      pre = new Date();
    } else if (!timer) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        handle.call(self, ...args);
        pre = new Date();
      }, interval);
    }
  };
}
// 根据出身日期计算年龄  str格式为2005-o6-04或者2005/06/04
export function ages(str) {
  let r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
  if (r == null) {
    return;
  }
  let d = new Date(r[1], r[3] - 1, r[4]);
  if (
    d.getFullYear() == r[1] &&
    d.getMonth() + 1 == r[3] &&
    d.getDate() == r[4]
  ) {
    let Y = new Date().getFullYear();
    return Y - r[1];
  }
  return "输入的日期格式错误！";
}
